<template>
  <div class="text--primary">
    <px-acompanhamentos allow-files
                        :item-type="messageType"
                        :item-id="contratacao.id"
                        :user="user"
                        @on-message="onMessage"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ContratacaoFreteService from '../contratacao-frete-service';

export default {
  props: {
    contratacao: Object,
  },
  data() {
    return {
      messageType: this.$px.types.MENSAGEM_CONTRATACAO_FRETE,
    };
  },
  computed: {
    ...mapGetters('user', ['user']),
  },
  methods: {
    onMessage() {
      ContratacaoFreteService.notificarNegociacao(this.contratacao.id);
    },
  },
};
</script>
